import { Link } from "react-router-dom";
import type { AppMode } from "@/types/embed";

interface ConfirmationScreenProps {
  reportId: string | null;
  email: string;
  offerId: string;
  mode: AppMode;
}

export function ConfirmationScreen({ reportId, email, offerId, mode }: ConfirmationScreenProps) {
  return (
    <div className="animate-fade-in text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
        <svg viewBox="0 0 24 24" className="h-8 w-8 text-green-600" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h1 className="text-2xl font-bold text-ink sm:text-3xl">Thanks, we're preparing your preview</h1>
      <p className="mx-auto mt-3 max-w-md text-lg text-ink-soft">
        We'll email it to {email ? <strong>{email}</strong> : "you"} when it's ready. This is
        usually under 30 minutes; larger documents can take longer.
      </p>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-muted">
        We've sent a confirmation email with a link to track progress. We'll email you again when
        your preview is ready.
      </p>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-muted">
        If you don't see it within a few minutes, check your spam folder and whitelist{" "}
        <strong>@requirementone.com</strong> so our updates reach your inbox.
      </p>

      {mode === "standalone" && reportId ? (
        <div className="mt-8">
          <Link className="r1-btn-primary" to={`/${offerId}/preview/${reportId}`}>
            View status now
          </Link>
        </div>
      ) : null}
    </div>
  );
}
